<template>
  <Grid gtc="1fr 1fr 1fr" gap="var(--r-space-sp)" class="widgets">
    <component :is="component.type" v-for="(component, index) of definition" :key="component.id">
      <template #widget-options>
        <q-btn flat round size="xs">
          <GearIcon :dark="component.type === 'usage-development'" />
          <RPopup :items="options" @popup-item="changeBoxContent($event, index)" />
        </q-btn>
      </template>
    </component>
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { cloneDeep } from 'lodash'
// Components
import GearIcon from '@/ui/icons/GearIcon'
import RPopup from '@/ui/RPopup'

export default {
  components: {
    PriceDevelopmentInOriginalCurrency: () => import('./charts/PriceDevelopmentInOriginalCurrency'),
    PriceDevelopmentInLocalCurrency: () => import('./charts/PriceDevelopmentInLocalCurrency'),
    UsageDevelopment: () => import('./charts/UsageDevelopment'),
    CostPerUseInOriginalCurrency: () => import('./charts/CostPerUseInOriginalCurrency'),
    CostPerUseInLocalCurrency: () => import('./charts/CostPerUseInLocalCurrency'),
    GearIcon,
    RPopup
  },

  data: () => ({
    definition: []
  }),

  computed: {
    usageLayout() {
      const layouts = this.$store.state.widgets.layout
      const subscriptionLayout = layouts.find(l => l.name === 'subscriptions')
      return subscriptionLayout.sub_contexts.find(s => s.name === 'usage')
    },

    initialDefinition() {
      return this.usageLayout.definition
    },

    availableElements() {
      return this.usageLayout.available_elements
    },

    defaultWidgets() {
      const defaultWidgets = [
        'price-development-in-original-currency',
        'usage-development',
        'cost-per-use-in-original-currency'
      ]
      const charts = this.availableElements.filter(widget => defaultWidgets.includes(widget.slug))

      return charts.map(el => ({
        id: el.id,
        type: el.slug,
        colspan: 4,
        name: el.name
      }))
    },

    options() {
      const filteredElements = this.availableElements.filter(el => el.enabled)

      return filteredElements.map(el => ({
        uid: el.id,
        label: el.name,
        name: el.slug
      }))
    }
  },

  created() {
    this.initDefinition(this.initialDefinition)
  },

  methods: {
    initDefinition(definition) {
      if (definition.length) this.definition = cloneDeep(definition)
      else this.definition = cloneDeep(this.defaultWidgets)
    },

    changeBoxContent({ name }, index) {
      let cards = cloneDeep(this.definition)
      cards[index].type = name
      this.updateLayout(cards)
    },

    updateLayout(definition) {
      apiTo
        .UPDATE_LAYOUT(this.usageLayout.id, { definition })
        .then(({ data }) => (this.definition = data.result.definition))
    }
  }
}
</script>
